import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';

import { globalDefines } from '../../app/app.constants';
import { TimetableProvider } from '../../providers/timetable/timetable';

@IonicPage()
@Component({
  selector: 'page-timetables',
  templateUrl: 'timetables.html',
})
export class TimetablesPage {

  timetables;

  constructor(
    public alertCtrl: AlertController,
    public navCtrl: NavController, 
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public timetableProvider: TimetableProvider,
  ) {
    this.timetables = timetableProvider.getTimetables();
  }

  addTimetable() {
    this.navCtrl.push('TimetableInfoPage', { mode: 'add' });
  }

  editTimetable(timetable) {
    this.navCtrl.push('TimetableInfoPage', { mode: 'edit', timetable: timetable });
  }

  infoTimetable(timetable) {
    this.navCtrl.push('TimetableInfoPage', { mode: 'info', timetable: timetable });
  }

  removeTimetable(timetable) {
    this.alertCtrl.create({
      title: 'Eliminar un horario',
      message: '¿Seguro que quiere eliminarlo?',
      buttons: [
        {
          text: 'No',
          handler: () => {}
        },
        {
          text: 'Sí',
          handler: () => {
            this.timetableProvider.remove(timetable.key).then(() => {
              this.showMessage('Horario eliminado')
            });
          }
        }
      ]
    }).present();
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/timetables/timetables.ts